import { useState } from 'react';
import { useApi } from '@glyph/core';
import { Button, Logo, TextInput } from '@glyph/ui';

/** `/invite?token=…`: the link an admin sends. New accounts choose a name and password; existing ones just join. */
export function InvitePage({ token, onDone }: { token: string; onDone: () => void }) {
  const api = useApi();
  const [name, setName] = useState('');
  const [pw, setPw] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await api.acceptInvite(token, name.trim(), pw);
      onDone();
    } catch (x) {
      setErr((x as Error).message || 'Could not accept the invite');
    } finally {
      setBusy(false);
    }
  };
  return (
    <main className="flex min-h-screen items-center justify-center bg-bg px-4 py-10">
      <form onSubmit={(e) => void submit(e)} className="flex w-full max-w-[380px] flex-col gap-6 rounded-2xl border border-line bg-panel p-7 md:rounded-xl">
        <Logo sub="Cloud" />
        <h1 className="m-0 text-2xl font-semibold leading-none">Join Glyph</h1>
        <label className="flex flex-col gap-2">
          <span className="micro text-fg3">Your name</span>
          <TextInput autoComplete="name" value={name} onChange={(e) => setName(e.target.value)} required block autoFocus />
        </label>
        <label className="flex flex-col gap-2">
          <span className="micro text-fg3">Password</span>
          <TextInput type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} minLength={12} block />
          <span className="font-mono text-xs text-fg4">12 CHARACTERS OR MORE · LEAVE EMPTY IF YOU ALREADY HAVE AN ACCOUNT</span>
        </label>
        {err && <span className="text-sm text-warn">{err}</span>}
        <Button type="submit" variant="primary" size="lg" disabled={busy || !name.trim()}>
          {busy ? 'Joining…' : 'Join'}
        </Button>
      </form>
    </main>
  );
}
